// =============================================================
// 檔案名稱：roles.js
// 版本：V1.01
// 日期：2025/07/19
// 主要功能與職責：
//   定義系統用戶角色常數，統一管理角色名稱與說明。
// 這個檔案是做什麼的？
//   提供角色常數，供權限判斷與 UI 顯示使用。
//   解決角色名稱分散、易出錯的問題。
// 更新歷史：
// V1.01 - 初版建立
// 注意事項：
//   修改時需同步更新 roleUtils.js 及 Firestore Rules。
// 關連檔案：roleUtils.js, firestore.rules
// =============================================================

export const ROLE_ADMIN = 'admin';      // 管理員
export const ROLE_OPERATOR = 'operator';// 營運商
export const ROLE_PARTNER = 'partner';  // 夥伴

export const ROLE_LABELS = {
  [ROLE_ADMIN]: '管理員',
  [ROLE_OPERATOR]: '營運商',
  [ROLE_PARTNER]: '夥伴',
};

export const ALL_ROLES = [ROLE_ADMIN, ROLE_OPERATOR, ROLE_PARTNER]; 